(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cure-tail-probiotic"] && !Shopify.designMode) return;
  try {
    
(function(){
  function rafThrottle(fn){
    var ticking=false;
    return function(){
      if(ticking) return;
      ticking=true;
      requestAnimationFrame(function(){
        ticking=false;
        fn();
      });
    };
  }

  function initWhenNear(el, fn){
    if(!el) return;
    if(!('IntersectionObserver' in window)){
      fn();
      return;
    }
    var io=new IntersectionObserver(function(entries){
      if(entries[0] && entries[0].isIntersecting){
        io.disconnect();
        fn();
      }
    },{rootMargin:'450px 0px'});
    io.observe(el);
  }

  function initRoot(root){
    if(!root || root.getAttribute('data-ctp-ready')==='1') return;
    root.setAttribute('data-ctp-ready','1');

    /* Product gallery */
    var gallery=root.querySelector('.ctp-gallery');
    if(gallery){
      var main=gallery.querySelector('.ctp-main-img img');
      gallery.addEventListener('click',function(e){
        var thumb=e.target.closest ? e.target.closest('.ctp-thumb') : null;
        if(!thumb || !gallery.contains(thumb)) return;

        var full=thumb.getAttribute('data-full');
        var set=thumb.getAttribute('data-srcset');
        if(main && full){
          main.src=full;
          if(set) main.srcset=set;
        }

        var active=gallery.querySelector('.ctp-thumb.is-active');
        if(active) active.classList.remove('is-active');
        thumb.classList.add('is-active');
      });
    }

    /* Variant selector / add-to-cart label */
    root.addEventListener('change',function(e){
      var radio=e.target;
      if(!radio || !radio.matches('.ctp-pack input[name="id"]')) return;

      var packs=root.querySelectorAll('.ctp-pack');
      for(var i=0;i<packs.length;i++) packs[i].classList.remove('is-active');

      var pack=radio.closest ? radio.closest('.ctp-pack') : null;
      if(pack) pack.classList.add('is-active');

      var btn=root.querySelector('button.ctp-cta');
      if(btn){
        btn.textContent=(btn.getAttribute('data-cta-label')||'ADD TO CART')+' · '+radio.getAttribute('data-price');
      }
    });

    /* Ingredient modal */
    var modal=root.querySelector('[data-ctp-ing-modal]');
    var openBtn=root.querySelector('[data-ctp-ing-open]');
    if(modal && openBtn){
      var closeBtns=modal.querySelectorAll('[data-ctp-ing-close]');

      function openModal(){
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden','false');
        document.documentElement.style.overflow='hidden';
        document.body.style.overflow='hidden';
      }

      function closeModal(){
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden','true');
        document.documentElement.style.overflow='';
        document.body.style.overflow='';
      }

      openBtn.addEventListener('click',openModal);
      for(var c=0;c<closeBtns.length;c++) closeBtns[c].addEventListener('click',closeModal);

      document.addEventListener('keydown',function(e){
        if(e.key==='Escape' && modal.classList.contains('is-open')) closeModal();
      });
    }

    /* Top review carousel: initialize only when near viewport */
    var review=root.querySelector('.cpr');
    initWhenNear(review,function(){
      var track=review.querySelector('.cpr-track');
      if(!track) return;

      var cards=Array.prototype.slice.call(review.querySelectorAll('.cpr-card'));
      var filters=review.querySelectorAll('.cpr-filter');
      var prev=review.querySelector('.cpr-prev');
      var next=review.querySelector('.cpr-next');
      var dots=Array.prototype.slice.call(review.querySelectorAll('.cpr-dots span'));

      function shownCards(){
        return cards.filter(function(card){return !card.classList.contains('is-hidden');});
      }

      function cardStep(){
        var shown=shownCards();
        if(!shown.length) return track.clientWidth || 1;
        var gap=parseFloat(getComputedStyle(track).gap || '0') || 0;
        return shown[0].getBoundingClientRect().width+gap;
      }

      function syncDots(){
        if(!dots.length) return;
        var shown=shownCards();
        var step=cardStep() || 1;
        var index=Math.round(track.scrollLeft/step);
        index=Math.max(0,Math.min(shown.length-1,index));
        dots.forEach(function(dot,i){
          dot.style.display=i<shown.length?'':'none';
          dot.classList.toggle('is-active',i===index);
        });
      }

      for(var f=0;f<filters.length;f++){
        filters[f].addEventListener('click',function(){
          for(var j=0;j<filters.length;j++) filters[j].classList.remove('is-active');
          this.classList.add('is-active');

          var filter=this.getAttribute('data-filter');
          cards.forEach(function(card){
            var cats=card.getAttribute('data-cat')||'';
            card.classList.toggle('is-hidden',!(filter==='all'||cats.indexOf(filter)!==-1));
          });

          track.scrollTo({left:0,behavior:'smooth'});
          window.setTimeout(syncDots,180);
        });
      }

      if(next) next.addEventListener('click',function(){track.scrollBy({left:cardStep(),behavior:'smooth'});});
      if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-cardStep(),behavior:'smooth'});});
      track.addEventListener('scroll',rafThrottle(syncDots),{passive:true});
      syncDots();
    });

    /* Ingredient carousel: initialize only when near viewport */
    var slider=root.querySelector('[data-ctp-slider]');
    initWhenNear(slider,function(){
      var track=slider.querySelector('.ctp-slider-track');
      if(!track) return;

      var slides=Array.prototype.slice.call(track.querySelectorAll('.ctp-slide'));
      var dots=slider.querySelector('[data-ctp-dots]');
      var prev=slider.querySelector('[data-ctp-prev]');
      var next=slider.querySelector('[data-ctp-next]');

      function step(){
        if(!slides.length) return 1;
        var gap=parseFloat(getComputedStyle(track).gap || '0') || 0;
        return slides[0].getBoundingClientRect().width+gap;
      }

      function build(){
        if(!dots) return;
        dots.innerHTML='';
        slides.forEach(function(_,i){
          var b=document.createElement('button');
          b.type='button';
          b.className='ctp-dot'+(i===0?' is-active':'');
          b.setAttribute('aria-label','Go to ingredient '+(i+1));
          b.addEventListener('click',function(){track.scrollTo({left:i*step(),behavior:'smooth'});});
          dots.appendChild(b);
        });
      }

      function sync(){
        if(!dots) return;
        var i=Math.round(track.scrollLeft/(step()||1));
        var children=Array.prototype.slice.call(dots.children);
        children.forEach(function(d,k){d.classList.toggle('is-active',k===i);});
      }

      if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
      if(next) next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
      track.addEventListener('scroll',rafThrottle(sync),{passive:true});
      build();
      sync();
    });

    /* Results timeline: reliable scroll tracking */
    var results=root.querySelector('[data-ctp-results]');
    if(results){
      var rWrap=results.querySelector('[data-ctp-results-wrap]');
      var rLine=results.querySelector('[data-ctp-results-line]');
      var rChew=results.querySelector('[data-ctp-results-chew]');
      var rSteps=Array.prototype.slice.call(results.querySelectorAll('[data-ctp-result-step]'));

      function updateResultsTimeline(){
        if(!rWrap || !rLine || !rChew || !rSteps.length) return;

        var lineRect=rLine.getBoundingClientRect();
        var vh=window.innerHeight || document.documentElement.clientHeight;
        var travel=Math.max(0,rLine.offsetHeight-rChew.offsetHeight);

        /* Match the PetCura behaviour: the chew follows the page as the
           vertical timeline passes through the middle of the viewport. */
        var scrolled=(vh*0.50)-lineRect.top;
        var p=scrolled/Math.max(1,lineRect.height);
        p=Math.max(0,Math.min(1,p));

        rChew.style.top=(p*travel)+'px';

        var chewRect=rChew.getBoundingClientRect();
        var chewY=chewRect.top+(chewRect.height*.52);

        rSteps.forEach(function(step,i){
          var dot=step.querySelector('.ctp-time-dot');
          var dotY;

          if(dot){
            var dotRect=dot.getBoundingClientRect();
            dotY=dotRect.top+(dotRect.height/2);
          }else{
            var stepRect=step.getBoundingClientRect();
            dotY=stepRect.top+12;
          }

          step.classList.toggle('is-active',dotY<=chewY+8 || (i===0 && p<.06));
        });
      }

      var queueResults=rafThrottle(updateResultsTimeline);

      /* Keep this listener permanently attached. It is passive and
         requestAnimationFrame-throttled, so the performance cost is tiny,
         while avoiding browsers occasionally pausing an IntersectionObserver
         before the timeline animation has started. */
      window.addEventListener('scroll',queueResults,{passive:true});
      window.addEventListener('resize',queueResults,{passive:true});
      window.addEventListener('load',queueResults,{passive:true});
      window.addEventListener('pageshow',queueResults,{passive:true});

      queueResults();
      window.setTimeout(queueResults,120);
      window.setTimeout(queueResults,500);
    }

    /* Progress carousel: initialize only when near viewport */
    var progress=root.querySelector('[data-ctp-progress]');
    initWhenNear(progress,function(){
      var pTrack=progress.querySelector('[data-ctp-progress-track]');
      if(!pTrack) return;

      var pCards=Array.prototype.slice.call(progress.querySelectorAll('.ctp-progress-card'));
      var pDots=progress.querySelector('[data-ctp-progress-dots]');
      var pPrev=progress.querySelector('[data-ctp-progress-prev]');
      var pNext=progress.querySelector('[data-ctp-progress-next]');

      function pStep(){
        if(!pCards.length) return 1;
        var gap=parseFloat(getComputedStyle(pTrack).gap || '0') || 0;
        return pCards[0].getBoundingClientRect().width+gap;
      }

      function pBuild(){
        if(!pDots) return;
        pDots.innerHTML='';
        pCards.forEach(function(_,i){
          var dot=document.createElement('button');
          dot.type='button';
          dot.className='ctp-progress-dot'+(i===0?' is-active':'');
          dot.setAttribute('aria-label','Go to progress card '+(i+1));
          dot.addEventListener('click',function(){pTrack.scrollTo({left:i*pStep(),behavior:'smooth'});});
          pDots.appendChild(dot);
        });
      }

      function pSync(){
        if(!pDots) return;
        var i=Math.round(pTrack.scrollLeft/(pStep()||1));
        i=Math.max(0,Math.min(pCards.length-1,i));
        Array.prototype.slice.call(pDots.children).forEach(function(dot,k){
          dot.classList.toggle('is-active',k===i);
        });
      }

      if(pPrev) pPrev.addEventListener('click',function(){pTrack.scrollBy({left:-pStep(),behavior:'smooth'});});
      if(pNext) pNext.addEventListener('click',function(){pTrack.scrollBy({left:pStep(),behavior:'smooth'});});
      pTrack.addEventListener('scroll',rafThrottle(pSync),{passive:true});
      pBuild();
      pSync();
    });
  }

  function boot(){
    var roots=document.querySelectorAll('.ctp-probiotic');
    for(var i=0;i<roots.length;i++) initRoot(roots[i]);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();

  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
